module.exports = __webpack_public_path__ + "static/media/bg-blue_hover.305bd1fe.jpeg";